export const METROS = [
    {
        slug: "delhi",
        city: "Delhi",
        metaTitle: "Marketing Agency in Delhi | Brand & Sales Growth Partner — ALBL",
        heroTitle: "BRAND, MARKETING & SALES GROWTH PARTNER IN DELHI.",
        heroSub: "Big-brand marketing thinking from Alaknanda, New Delhi — for businesses that want strategy, not packages.",
        intro: [
            "Delhi is one of the most demanding consumer markets in the country. Customers here have seen every kind of advertising, compare everything, and forget fast. Winning in Delhi takes sharper positioning and more disciplined execution than most agencies are built for.",
            "ALBL's registered office is in Alaknanda, New Delhi. From here, we work with businesses that want marketing built on strategy — not monthly posting packages. The same big-brand discipline that shapes our work across Central Madhya Pradesh is available to ambitious Delhi businesses.",
        ],
        focusTitle: "Where we help Delhi businesses grow",
        focus: [
            "Brand positioning that survives Delhi's advertising clutter",
            "Retail and trade marketing across Delhi's wholesale and retail markets",
            "Digital growth — search, social and landing pages built to convert",
            "Customer acquisition systems measured in enquiries, not impressions",
        ],
        local: "From Lajpat Nagar and Karol Bagh to Nehru Place, Rohini and the NCR corridors, Delhi is not one market — it is many. We build campaigns around the specific catchments and customer segments your business actually serves.",
        photos: [
            {
                src: "https://upload.wikimedia.org/wikipedia/commons/4/49/India_Gate_campus_in_the_evening_05.jpg",
                alt: "India Gate campus in the evening, New Delhi",
                caption: "India Gate, New Delhi",
            },
            {
                src: "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/33/Connaught_High_Street%2C_Connaught_Place%2C_New_Delhi.jpg/1280px-Connaught_High_Street%2C_Connaught_Place%2C_New_Delhi.jpg",
                alt: "Connaught Place high street commercial area, New Delhi",
                caption: "Connaught Place — Delhi's iconic commercial district",
            },
            {
                src: "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/6f/Connaught_Place%2C_New_Delhi_at_night.jpg/1280px-Connaught_Place%2C_New_Delhi_at_night.jpg",
                alt: "Connaught Place at night, New Delhi",
                caption: "Connaught Place at night, New Delhi",
            },
        ],
    },
    {
        slug: "bhopal",
        city: "Bhopal",
        metaTitle: "Marketing Agency in Bhopal | Brand & Sales Growth Partner — ALBL",
        heroTitle: "BRAND, MARKETING & SALES GROWTH PARTNER IN BHOPAL.",
        heroSub: "Big-brand marketing thinking for ambitious Bhopal businesses — from MP Nagar to the city's fastest-growing corridors.",
        intro: [
            "Bhopal is not a small-town market anymore. From MP Nagar and New Market to the fast-growing Kolar Road and Hoshangabad Road corridors, customers here compare everything — and advertising clutter is high. In this market, the businesses that win are not the loudest. They are the clearest.",
            "ALBL works with Bhopal businesses from our branch office adjacent to DB Mall, MP Nagar. We start with the business — what you sell, who should buy it, and why customers should choose you — then build brand, marketing and sales execution around those answers.",
        ],
        focusTitle: "Where we help Bhopal businesses grow",
        focus: [
            "Brand positioning that cuts through Bhopal's advertising clutter",
            "Retail and trade marketing across the city's commercial belts",
            "Digital growth — websites, Google and Meta campaigns built to produce enquiries",
            "Customer acquisition for real estate, education, healthcare, hospitality and retail businesses",
        ],
        local: "Bhopal's growth corridors — MP Nagar, New Market, Arera Colony, Kolar Road, Hoshangabad Road and Bawadiya Kalan — each behave like a different market. We build campaigns around the specific catchments your business actually serves, measured in enquiries and customers rather than impressions.",
        photos: [
            {
                src: "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/bf/Panchanan_Building_New_Market_Bhopal.jpg/1280px-Panchanan_Building_New_Market_Bhopal.jpg",
                alt: "New Market commercial area in Bhopal, Madhya Pradesh",
                caption: "New Market — one of Bhopal's busiest commercial districts",
            },
            {
                src: "https://upload.wikimedia.org/wikipedia/commons/5/52/Taj-ul-Masajid_Aerial_Photo.jpg",
                alt: "Aerial view of Taj-ul-Masajid, Bhopal",
                caption: "Taj-ul-Masajid — the city ALBL's Bhopal branch calls home",
            },
            {
                src: "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/ca/Upper_Lake%2C_Bhopal%2C_M.P.jpg/1280px-Upper_Lake%2C_Bhopal%2C_M.P.jpg",
                alt: "Upper Lake (Bada Talab) in Bhopal, Madhya Pradesh",
                caption: "Upper Lake (Bada Talab), Bhopal",
            },
        ],
    },
    {
        slug: "indore",
        city: "Indore",
        metaTitle: "Marketing Agency in Indore | Brand & Sales Growth Partner — ALBL",
        heroTitle: "BRAND, MARKETING & SALES GROWTH PARTNER IN INDORE.",
        heroSub: "Serious brand-marketing thinking for the commercial capital of Madhya Pradesh.",
        intro: [
            "Indore is the commercial engine of Madhya Pradesh — a city of traders, manufacturers, food businesses and a fast-modernising consumer base. Customers here are spoilt for choice. Businesses that look and sound like everyone else get compared on price; businesses with a clear brand get chosen on purpose.",
            "ALBL brings structured brand, marketing and sales-growth thinking to Indore businesses — the same discipline that drives big national brands, adapted to how the Indore market actually buys.",
        ],
        focusTitle: "Where we help Indore businesses grow",
        focus: [
            "Brand strategy for crowded categories — food, retail, education, healthcare and services",
            "Trade and distribution marketing across Indore and the wider Malwa region",
            "Digital growth and local SEO that turns searches into enquiries",
            "Customer acquisition systems with disciplined follow-up and measurement",
        ],
        local: "From Rajwada and Sarafa to Vijay Nagar, Palasia and the Super Corridor, Indore's catchments buy differently. We map marketing to the geography and the customer your business actually serves — then measure what it produces.",
    },
    {
        slug: "jabalpur",
        city: "Jabalpur",
        metaTitle: "Marketing Agency in Jabalpur | Brand & Sales Growth Partner — ALBL",
        heroTitle: "BRAND, MARKETING & SALES GROWTH PARTNER IN JABALPUR.",
        heroSub: "Structured marketing thinking for the gateway of the Mahakaushal region.",
        intro: [
            "Jabalpur is the gateway to the Mahakaushal region — a hub for education, trade, professional services and distribution that feeds Katni, Mandla, Narsinghpur, Chhindwara and the districts around it. Businesses here rarely serve just one city; they serve an entire region.",
            "That changes the marketing problem. ALBL helps Jabalpur businesses build brands and distribution-focused marketing that travel beyond the city — positioning that dealers trust, communication that works across the region, and digital presence that captures demand where it actually starts.",
        ],
        focusTitle: "Where we help Jabalpur businesses grow",
        focus: [
            "Regional distribution and dealer-network marketing for the Mahakaushal belt",
            "Brand positioning for established and multi-generation family businesses",
            "Digital growth for education, healthcare, hospitality and service businesses",
            "Hyperlocal campaigns built around Jabalpur's real commercial catchments",
        ],
        local: "Wright Town, Napier Town, Sadar, Vijay Nagar and Madan Mahal each move differently — and so do the district markets Jabalpur supplies. We build marketing around that real geography, not generic metro templates.",
    },
];

export const metroBySlug = (slug) => METROS.find((m) => m.slug === slug);

export const METRO_FAQS = {
    bhopal: [
        {
            q: "Does ALBL have an office in Bhopal?",
            a: "Yes. ALBL's branch office is located adjacent to DB Mall, MP Nagar, Bhopal — in the heart of the city's commercial district. Our registered office is in Alaknanda, New Delhi.",
        },
        {
            q: "What services does ALBL offer in Bhopal?",
            a: "Brand strategy, retail and trade marketing, digital growth (websites, Google and Meta campaigns), customer acquisition and sales-focused marketing — all built around your business objective rather than a fixed package.",
        },
        {
            q: "Does ALBL work with small and local businesses in Bhopal?",
            a: "Yes. ALBL brings professional brand and sales-marketing thinking to ambitious local and growing businesses across Bhopal — from MP Nagar traders to businesses in the city's growing corridors.",
        },
        {
            q: "Can ALBL help my Bhopal business get more enquiries?",
            a: "ALBL builds marketing around customer acquisition — local SEO, hyperlocal campaigns and conversion-focused execution measured in enquiries and sales. Results depend on the business, market, offer and execution.",
        },
    ],
    indore: [
        {
            q: "Does ALBL work with businesses in Indore?",
            a: "Yes. Indore is one of ALBL's metro markets, along with Bhopal and Jabalpur — in addition to our home markets of Narmadapuram and Itarsi.",
        },
        {
            q: "What makes ALBL different from other marketing agencies in Indore?",
            a: "Most agencies sell posts, reels and packages. ALBL starts with the business — what you sell, who should buy it and why customers should choose you — then builds marketing around those answers, measured in enquiries and sales.",
        },
        {
            q: "Does ALBL handle trade and distribution marketing in Indore?",
            a: "Yes. Retail visibility, dealer and distributor activation, merchandising and market execution across Indore and the wider Malwa region are core ALBL services, built on professional big-brand experience.",
        },
        {
            q: "Does ALBL provide digital marketing services in Indore?",
            a: "Yes — social media, websites, landing pages, Google and Meta advertising, content and local SEO, always tied to customer acquisition and business outcomes rather than vanity metrics.",
        },
    ],
    jabalpur: [
        {
            q: "Does ALBL serve businesses in Jabalpur?",
            a: "Yes. ALBL works with businesses in Jabalpur and the wider Mahakaushal region, alongside Narmadapuram, Itarsi, Bhopal and Indore.",
        },
        {
            q: "Can ALBL help with regional distribution marketing from Jabalpur?",
            a: "Yes. Jabalpur businesses often serve the entire Mahakaushal belt. ALBL builds dealer-network marketing, retail visibility and regional campaign execution designed for multi-district reach.",
        },
        {
            q: "Does ALBL provide digital marketing in Jabalpur?",
            a: "Yes. Websites, landing pages, Google and Meta campaigns, content and local SEO — as one part of a broader brand and sales-growth approach.",
        },
        {
            q: "What types of Jabalpur businesses does ALBL work with?",
            a: "Retailers, education businesses, healthcare, hospitality, real estate, distributors, manufacturers, service businesses and emerging local brands — any ambitious business that wants structured growth.",
        },
    ],
    delhi: [
        {
            q: "Does ALBL have an office in Delhi?",
            a: "Yes. ALBL's registered office is in Alaknanda, New Delhi. Our branch office is adjacent to DB Mall, MP Nagar, Bhopal.",
        },
        {
            q: "What services does ALBL offer in Delhi?",
            a: "Brand strategy, retail and trade marketing, digital growth, customer acquisition and sales-focused marketing — every engagement built around your business objective, not a fixed package.",
        },
        {
            q: "How is ALBL different from other marketing agencies in Delhi?",
            a: "Most agencies sell posts, reels and packages. ALBL starts with the business — what you sell, who should buy it and why customers should choose you — then builds marketing around those answers, measured in enquiries and sales.",
        },
        {
            q: "Does ALBL work with small and growing businesses in Delhi?",
            a: "Yes. ALBL brings professional brand and sales-marketing thinking to ambitious local and growing businesses — in Delhi and across our Central Madhya Pradesh markets.",
        },
    ],
};

export const HI_METROS = {
    delhi: {
        heroTitle: "दिल्ली में ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर।",
        heroSub: "अलकनंदा, नई दिल्ली से — बड़े ब्रांडों वाली मार्केटिंग सोच, उन बिज़नेस के लिए जिन्हें पैकेज नहीं, स्ट्रैटेजी चाहिए।",
        intro: [
            "दिल्ली देश के सबसे कठिन कंज़्यूमर बाज़ारों में से एक है। यहाँ का ग्राहक हर तरह का विज्ञापन देख चुका है, हर चीज़ की तुलना करता है, और जल्दी भूल जाता है। दिल्ली में जीतने के लिए तेज़ पोज़िशनिंग और अनुशासित एक्ज़ीक्यूशन चाहिए — जिसके लिए ज़्यादातर एजेंसियां बनी ही नहीं हैं।",
            "ALBL का रजिस्टर्ड ऑफ़िस अलकनंदा, नई दिल्ली में है। यहाँ से हम उन बिज़नेस के साथ काम करते हैं जो स्ट्रैटेजी पर टिकी मार्केटिंग चाहते हैं — महीने भर की पोस्टिंग के पैकेज नहीं। मध्य प्रदेश के हमारे काम को आकार देने वाला वही बड़े-ब्रांड अनुशासन अब दिल्ली के महत्वाकांक्षी बिज़नेस के लिए भी उपलब्ध है।",
        ],
        focusTitle: "दिल्ली के बिज़नेस की ग्रोथ में हम कहाँ मदद करते हैं",
        focus: [
            "दिल्ली के विज्ञापन-शोर में भी टिकने वाली ब्रांड पोज़िशनिंग",
            "दिल्ली के थोक और खुदरा बाज़ारों में रिटेल और ट्रेड मार्केटिंग",
            "डिजिटल ग्रोथ — सर्च, सोशल और ऐसे लैंडिंग पेज जो कन्वर्ट करें",
            "enquiries में मापे जाने वाले कस्टमर एक्विज़िशन सिस्टम — impressions में नहीं",
        ],
        local: "लाजपत नगर और करोल बाग़ से लेकर नेहरू प्लेस, रोहिणी और NCR के कॉरिडोर तक — दिल्ली एक बाज़ार नहीं, कई बाज़ार है। हम कैंपेन उन्हीं catchments और ग्राहक-सेगमेंट के इर्द-गिर्द बनाते हैं जिन्हें आपका बिज़नेस सच में serve करता है।",
    },
    bhopal: {
        heroTitle: "भोपाल में ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर।",
        heroSub: "MP Nagar से लेकर शहर के सबसे तेज़ी से बढ़ते कॉरिडोर तक — महत्वाकांक्षी भोपाल बिज़नेस के लिए बड़े ब्रांडों वाली मार्केटिंग सोच।",
        intro: [
            "भोपाल अब छोटे शहरों जैसा बाज़ार नहीं रहा। MP Nagar और न्यू मार्केट से लेकर कोलार रोड और होशंगाबाद रोड के तेज़ी से बढ़ते कॉरिडोर तक — यहाँ का ग्राहक हर चीज़ की तुलना करता है, और विज्ञापनों का शोर बहुत है। इस बाज़ार में जीतने वाले सबसे ज़्यादा शोर मचाने वाले नहीं, सबसे साफ़ दिखने वाले बिज़नेस होते हैं।",
            "ALBL भोपाल के बिज़नेस के साथ अपने ब्रांच ऑफ़िस से काम करती है — DB Mall के पास, MP Nagar। हम शुरुआत बिज़नेस से करते हैं — आप क्या बेचते हैं, कौन ख़रीदे, ग्राहक आपको ही क्यों चुने — फिर ब्रांड, मार्केटिंग और सेल्स एक्ज़ीक्यूशन इन्हीं जवाबों के इर्द-गिर्द बनाते हैं।",
        ],
        focusTitle: "भोपाल के बिज़नेस की ग्रोथ में हम कहाँ मदद करते हैं",
        focus: [
            "भोपाल के विज्ञापन-शोर को चीरने वाली ब्रांड पोज़िशनिंग",
            "शहर की कमर्शियल बेल्ट में रिटेल और ट्रेड मार्केटिंग",
            "डिजिटल ग्रोथ — वेबसाइट, Google और Meta कैंपेन जो enquiries लाएँ",
            "रियल एस्टेट, एजुकेशन, हेल्थकेयर, हॉस्पिटैलिटी और रिटेल के लिए कस्टमर एक्विज़िशन",
        ],
        local: "भोपाल के ग्रोथ कॉरिडोर — MP Nagar, न्यू मार्केट, अरेरा कॉलोनी, कोलार रोड, होशंगाबाद रोड और बावड़िया कलाँ — हर एक अलग बाज़ार जैसा चलता है। हम कैंपेन उन्हीं catchments के अनुसार बनाते हैं जिन्हें आपका बिज़नेस सच में serve करता है — impressions नहीं, enquiries और ग्राहकों से मापा हुआ।",
    },
    indore: {
        heroTitle: "इंदौर में ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर।",
        heroSub: "मध्य प्रदेश की कमर्शियल राजधानी के लिए गंभीर ब्रांड-मार्केटिंग सोच।",
        intro: [
            "इंदौर मध्य प्रदेश का कमर्शियल इंजन है — व्यापारियों, मैन्युफ़ैक्चरर्स, फ़ूड बिज़नेस और तेज़ी से आधुनिक होते उपभोक्ताओं का शहर। यहाँ ग्राहक के पास विकल्पों की भरमार है। जो बिज़नेस सब जैसे दिखते और बोलते हैं, उनकी तुलना दाम से होती है; जिनकी ब्रांड साफ़ होती है, उन्हें जानबूझकर चुना जाता है।",
            "ALBL इंदौर के बिज़नेस के लिए व्यवस्थित ब्रांड, मार्केटिंग और सेल्स-ग्रोथ सोच लाती है — वही अनुशासन जो बड़े राष्ट्रीय ब्रांड्स को चलाता है, इंदौर के बाज़ार की ख़रीद-हक़ीक़त के अनुसार ढला हुआ।",
        ],
        focusTitle: "इंदौर के बिज़नेस की ग्रोथ में हम कहाँ मदद करते हैं",
        focus: [
            "भीड़ भरी categories के लिए ब्रांड स्ट्रैटेजी — फ़ूड, रिटेल, एजुकेशन, हेल्थकेयर और सर्विसेज़",
            "इंदौर और पूरे मालवा क्षेत्र में ट्रेड और डिस्ट्रीब्यूशन मार्केटिंग",
            "डिजिटल ग्रोथ और लोकल SEO जो सर्च को enquiries में बदले",
            "अनुशासित फ़ॉलो-अप और मेज़रमेंट वाले कस्टमर एक्विज़िशन सिस्टम",
        ],
        local: "राजवाड़ा और सराफ़ा से लेकर विजय नगर, पालासिया और सुपर कॉरिडोर तक — इंदौर के हर catchment की ख़रीद-आदत अलग है। हम मार्केटिंग उसी geography और ग्राहक के अनुसार बनाते हैं जिसे आपका बिज़नेस सच में serve करता है — और फिर नतीजा मापते हैं।",
    },
    jabalpur: {
        heroTitle: "जबलपुर में ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर।",
        heroSub: "महाकौशल क्षेत्र के गेटवे के लिए व्यवस्थित मार्केटिंग सोच।",
        intro: [
            "जबलपुर महाकौशल क्षेत्र का गेटवे है — एजुकेशन, ट्रेड, प्रोफ़ेशनल सर्विसेज़ और डिस्ट्रीब्यूशन का हब, जो कटनी, मंडला, नरसिंहपुर, छिंदवाड़ा और आसपास के ज़िलों को feed करता है। यहाँ के बिज़नेस शायद ही सिर्फ़ एक शहर serve करते हैं; वे पूरे इलाके को serve करते हैं।",
            "इससे मार्केटिंग की समस्या बदल जाती है। ALBL जबलपुर के बिज़नेस के लिए ऐसे ब्रांड और डिस्ट्रीब्यूशन-फ़ोकस्ड मार्केटिंग बनाती है जो शहर से बाहर तक चले — ऐसी पोज़िशनिंग जिस पर डीलर भरोसा करें, ऐसा कम्युनिकेशन जो पूरे इलाके में काम करे, और ऐसी डिजिटल मौजूदगी जो demand को वहीं पकड़े जहाँ वह शुरू होती है।",
        ],
        focusTitle: "जबलपुर के बिज़नेस की ग्रोथ में हम कहाँ मदद करते हैं",
        focus: [
            "महाकौशल बेल्ट के लिए रीजनल डिस्ट्रीब्यूशन और डीलर-नेटवर्क मार्केटिंग",
            "स्थापित और पीढ़ियों पुराने फ़ैमिली बिज़नेस के लिए ब्रांड पोज़िशनिंग",
            "एजुकेशन, हेल्थकेयर, हॉस्पिटैलिटी और सर्विस बिज़नेस के लिए डिजिटल ग्रोथ",
            "जबलपुर के असली कमर्शियल catchments के इर्द-गिर्द हाइपरलोकल कैंपेन",
        ],
        local: "राइट टाउन, नेपियर टाउन, सदर, विजय नगर और मदन महल — हर इलाका अलग चलता है; और जबलपुर जिन ज़िला बाज़ारों को supply करता है वे भी। हम मार्केटिंग इसी असली geography के अनुसार बनाते हैं — जेनरिक मेट्रो टेम्पलेट के अनुसार नहीं।",
    },
};

export const HI_METRO_FAQS = {
    delhi: [
        {
            q: "क्या ALBL का दिल्ली में ऑफ़िस है?",
            a: "हाँ। ALBL का रजिस्टर्ड ऑफ़िस अलकनंदा, नई दिल्ली में है। हमारा ब्रांच ऑफ़िस भोपाल के MP Nagar में, DB Mall के पास है।",
        },
        {
            q: "ALBL दिल्ली में कौन-सी सेवाएँ देती है?",
            a: "ब्रांड स्ट्रैटेजी, रिटेल और ट्रेड मार्केटिंग, डिजिटल ग्रोथ, कस्टमर एक्विज़िशन और सेल्स-फ़ोकस्ड मार्केटिंग — हर काम आपके बिज़नेस लक्ष्य के अनुसार, किसी तय पैकेज के अनुसार नहीं।",
        },
        {
            q: "ALBL दिल्ली की दूसरी मार्केटिंग एजेंसियों से अलग कैसे है?",
            a: "ज़्यादातर एजेंसियां पोस्ट, रील्स और पैकेज बेचती हैं। ALBL बिज़नेस से शुरुआत करती है — आप क्या बेचते हैं, कौन ख़रीदे, ग्राहक आपको ही क्यों चुने — फिर इन्हीं जवाबों के इर्द-गिर्द मार्केटिंग बनाती है, enquiries और सेल्स से मापी हुई।",
        },
        {
            q: "क्या ALBL दिल्ली के छोटे और बढ़ते बिज़नेस के साथ काम करती है?",
            a: "हाँ। ALBL प्रोफ़ेशनल ब्रांड और सेल्स-मार्केटिंग सोच महत्वाकांक्षी लोकल और बढ़ते बिज़नेस तक पहुँचाती है — दिल्ली में और मध्य प्रदेश के हमारे बाज़ारों में।",
        },
    ],
    bhopal: [
        {
            q: "क्या ALBL का भोपाल में ऑफ़िस है?",
            a: "हाँ। ALBL का ब्रांच ऑफ़िस DB Mall के पास, MP Nagar, भोपाल में है — शहर के कमर्शियल ज़िले के बीच। हमारा रजिस्टर्ड ऑफ़िस अलकनंदा, नई दिल्ली में है।",
        },
        {
            q: "ALBL भोपाल में कौन-सी सेवाएँ देती है?",
            a: "ब्रांड स्ट्रैटेजी, रिटेल और ट्रेड मार्केटिंग, डिजिटल ग्रोथ (वेबसाइट, Google और Meta कैंपेन), कस्टमर एक्विज़िशन और सेल्स-फ़ोकस्ड मार्केटिंग — सब आपके बिज़नेस लक्ष्य के अनुसार, किसी तय पैकेज के अनुसार नहीं।",
        },
        {
            q: "क्या ALBL भोपाल के छोटे और लोकल बिज़नेस के साथ काम करती है?",
            a: "हाँ। ALBL प्रोफ़ेशनल ब्रांड और सेल्स-मार्केटिंग सोच भोपाल के महत्वाकांक्षी लोकल और बढ़ते बिज़नेस तक पहुँचाती है — MP Nagar के व्यापारियों से लेकर शहर के बढ़ते कॉरिडोर के बिज़नेस तक।",
        },
        {
            q: "क्या ALBL मेरे भोपाल के बिज़नेस की enquiries बढ़ा सकती है?",
            a: "ALBL कस्टमर एक्विज़िशन के इर्द-गिर्द मार्केटिंग बनाती है — लोकल SEO, हाइपरलोकल कैंपेन और कन्वर्ज़न-फ़ोकस्ड एक्ज़ीक्यूशन, enquiries और सेल्स से मापा हुआ। नतीजे बिज़नेस, बाज़ार, ऑफर और एक्ज़ीक्यूशन पर निर्भर करते हैं।",
        },
    ],
    indore: [
        {
            q: "क्या ALBL इंदौर के बिज़नेस के साथ काम करती है?",
            a: "हाँ। इंदौर ALBL के मेट्रो बाज़ारों में से एक है — दिल्ली, भोपाल और जबलपुर के साथ; और हमारे होम मार्केट नर्मदापुरम-इतारसी के अलावा।",
        },
        {
            q: "ALBL इंदौर की दूसरी मार्केटिंग एजेंसियों से अलग कैसे है?",
            a: "ज़्यादातर एजेंसियां पोस्ट, रील्स और पैकेज बेचती हैं। ALBL बिज़नेस से शुरुआत करती है — आप क्या बेचते हैं, कौन ख़रीदे, ग्राहक आपको ही क्यों चुने — फिर इन्हीं जवाबों के इर्द-गिर्द मार्केटिंग बनाती है, enquiries और सेल्स से मापी हुई।",
        },
        {
            q: "क्या ALBL इंदौर में ट्रेड और डिस्ट्रीब्यूशन मार्केटिंग करती है?",
            a: "हाँ। इंदौर और पूरे मालवा क्षेत्र में रिटेल विज़िबिलिटी, डीलर-डिस्ट्रीब्यूटर एक्टिवेशन, मर्चंडाइज़िंग और मार्केट एक्ज़ीक्यूशन ALBL की मुख्य सेवाएँ हैं — बड़े ब्रांड्स के प्रोफ़ेशनल अनुभव पर आधारित।",
        },
        {
            q: "क्या ALBL इंदौर में डिजिटल मार्केटिंग सेवाएँ देती है?",
            a: "हाँ — सोशल मीडिया, वेबसाइट, लैंडिंग पेज, Google और Meta विज्ञापन, कंटेंट और लोकल SEO — हमेशा कस्टमर एक्विज़िशन और बिज़नेस नतीजों से जुड़ी, दिखावटी आंकड़ों से नहीं।",
        },
    ],
    jabalpur: [
        {
            q: "क्या ALBL जबलपुर के बिज़नेस को serve करती है?",
            a: "हाँ। ALBL जबलपुर और पूरे महाकौशल क्षेत्र के बिज़नेस के साथ काम करती है — दिल्ली, भोपाल, इंदौर, नर्मदापुरम और इतारसी के साथ।",
        },
        {
            q: "क्या ALBL जबलपुर से रीजनल डिस्ट्रीब्यूशन मार्केटिंग में मदद कर सकती है?",
            a: "हाँ। जबलपुर के बिज़नेस अक्सर पूरी महाकौशल बेल्ट serve करते हैं। ALBL मल्टी-डिस्ट्रिक्ट पहुँच के लिए डीलर-नेटवर्क मार्केटिंग, रिटेल विज़िबिलिटी और रीजनल कैंपेन एक्ज़ीक्यूशन बनाती है।",
        },
        {
            q: "क्या ALBL जबलपुर में डिजिटल मार्केटिंग देती है?",
            a: "हाँ। वेबसाइट, लैंडिंग पेज, Google और Meta कैंपेन, कंटेंट और लोकल SEO — ब्रांड और सेल्स-ग्रोथ की बड़ी स्ट्रैटेजी के एक हिस्से के रूप में।",
        },
        {
            q: "ALBL जबलपुर में किस तरह के बिज़नेस के साथ काम करती है?",
            a: "रिटेलर्स, एजुकेशन, हेल्थकेयर, हॉस्पिटैलिटी, रियल एस्टेट, डिस्ट्रीब्यूटर्स, मैन्युफ़ैक्चरर्स, सर्विस बिज़नेस और उभरते लोकल ब्रांड्स — कोई भी महत्वाकांक्षी बिज़नेस जो व्यवस्थित ग्रोथ चाहता है।",
        },
    ],
};
